<template>
    <el-dialog
        class="set-private"
        :visible.sync="setProcessingTimeVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Set Time"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="setTimeForm"
                :model="setTimeForm"
                :rules="rules"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="Select"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Please select Type',
                                },
                            ]"
                            prop="type"
                            size="small"
                        >
                            <el-radio-group
                                v-model="setTimeForm.type"
                                @change="typeChange"
                            >
                                <el-radio :label="1">SPU</el-radio>
                                <el-radio :label="2">SKU</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="setTimeForm.type == '1'">
                        <el-form-item label="SPU" prop="content" size="small" 
                            :rules="[
                                {
                                    required: true,
                                    message: 'Please input SPU',
                                },
                            ]">
                            <el-input
                                type="textarea"
                                v-model="setTimeForm.content"
                                :autosize="{ minRows: 5, maxRows: 10 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="setTimeForm.type == '2'">
                        <el-form-item label="SKU" prop="content" size="small"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Please input SKU',
                                },
                            ]">
                            <el-input
                                type="textarea"
                                v-model="setTimeForm.content"
                                :autosize="{ minRows: 5, maxRows: 10 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="Processing Time"
                            :rules="[
                                {
                                    required: true,
                                    message: 'Please select Processing Time',
                                },
                            ]"
                            prop="processing_time"
                            size="small"
                        >
                           <el-select
                            v-model="setTimeForm.processing_time"
                            clearable
                            filterable
                            size="small"
                        >
                            <el-option
                                :label="item.label"
                                :value="item.value"
                                v-for="item of processingList"
                                :key="item.value"
                            ></el-option>
                        </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="setProcessingTimeVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            setTimeForm: {
                type: 1,
                content: "",
                processing_time:""
            },
            rules: {},
            processingList:[
                {
                    label: "1-3 days",
                    value: 1,
                },
                {
                    label: "3-5 days",
                    value: 2,
                },
                {
                    label: "5-7 days",
                    value: 3,
                },
                {
                    label: "More than 7 days",
                    value: 4,
                },
            ]
        };
    },
    methods: {

        closeDialog() {
            this.userList = [];
            this.$refs["setTimeForm"].clearValidate();
            this.$refs["setTimeForm"].resetFields();
            this.$emit("update:setProcessingTimeVisible", false);
        },
        save() {
            this.$refs["setTimeForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .setProcessingTime(
                            {
                                type: this.setTimeForm.type,
                                content: this.setTimeForm.content.split("\n"),
                                processing_time: this.setTimeForm.processing_time
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res) {
                                if(res.errmsg != 'ok'){
                                    this.$message.warning({
                                        dangerouslyUseHTMLString: true,
                                        message: res.errmsg,
                                        showClose: true,
                                        duration: 3000
                                    });
                                }else{
                                    this.$message.success("Success!");
                                    this.closeDialog();
                                } 
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            })
            
        },
    },
    props: {
        setProcessingTimeVisible: Boolean,
    },
    watch: {
        setProcessingTimeVisible(val) {},
    },
};
</script>
<style lang="scss" scoped>
.set-private {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
